/**
 * @module mapbs.components.contextmenu.contextmenu
 */

import angular from 'angular';

import ngeoMiscToolActivate from 'ngeo/misc/ToolActivate.js';
import olInteractionDraw from 'ol/interaction/Draw.js';

const moduleContextmenu = angular.module('mapbsContextMenuModule', []);

/**
 * @type {!angular.Component}
 */
const contextMenuContoller = {
    controller: 'mapbsContextmenuController as cmCtrl',
    bindings: {
        map: '<mapbsContextmenuMap',
        contextmenuActive: '<mapbsContextmenuActive',
    },
};

moduleContextmenu.component('mapbsContextmenu', contextMenuContoller);

class ContextMenuController {
    /**
   * @param {!angular.Scope} $scope
   * @param {import('ngeo/misc/ToolActivate.js').default} ngeoToolActivateMgr
   * @constructor
   * @private
   * @ngInject
   */
    constructor($scope, ngeoToolActivateMgr) {
        this.scope = $scope;

        /**
     * @type {ol.Map}
     */
        this.map;

        /**
     * @type {boolean}
     */
        this.contextmenuActive;

        this.contextmenuDrawInteraction = new olInteractionDraw({
            type: /** @type{import("ol/geom/GeometryType.js")} */ ('Point'),
        });

        ngeoToolActivateMgr.registerTool(
            'mapTools',
            new ngeoMiscToolActivate(this, 'active'),
            false
        );

        this.scope.$watch(
            () => this.contextmenuActive,
            (newVal) => {
                const mapDiv = this.map.getTargetElement();
                if (newVal) {
                    this.map.addInteraction(this.contextmenuDrawInteraction);
                    mapDiv.addEventListener('click', this.fireContextmenuEvent);
                } else {
                    mapDiv.removeEventListener('click', this.fireContextmenuEvent);
                    this.map.removeInteraction(this.contextmenuDrawInteraction);
                }
            }
        );
    }

    /**
   * @private
   */
    fireContextmenuEvent(event) {
        const contextmenuEvent = document.createEvent('MouseEvents');
        contextmenuEvent.initMouseEvent(
            'contextmenu',
            event.bubbles,
            event.cancelable,
            event.view,
            event.detail,
            event.screenX,
            event.screenY,
            event.clientX,
            event.clientY,
            event.ctrlKey,
            event.altKey,
            event.shiftKey,
            event.metaKey,
            2,
            event.relatedTarget
        );
        event.target.dispatchEvent(contextmenuEvent);
    }
}

moduleContextmenu.controller('mapbsContextmenuController', ContextMenuController);

export default moduleContextmenu;
